import {Staff} from '../staff';

export class DevelopmentStaff extends Staff {

   constructor(json: any) {
      super(json);
   }
}



// WEBPACK FOOTER //
// ./src/app/models/game/company/business-units/development/development-staff.ts